// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AgentUpdatesRouteImport } from './routes/agent-updates'
import { Route as AmlRealEstateAgentsRouteImport } from './routes/aml-real-estate-agents'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AroonaRouteImport } from './routes/aroona'
import { Route as BaringaRouteImport } from './routes/baringa'
import { Route as BatteryHillRouteImport } from './routes/battery-hill'
import { Route as BlueMoonPropertyRouteImport } from './routes/blue-moon-property'
import { Route as BodyCorporateScarboroughRouteImport } from './routes/body-corporate-scarborough'
import { Route as BrisbaneRouteImport } from './routes/brisbane'
import { Route as BuderimRouteImport } from './routes/buderim'
import { Route as BusinessSaleChecklistRouteImport } from './routes/business-sale-checklist'
import { Route as BusinessSalesRouteImport } from './routes/business-sales'
import { Route as BusinessSuccessionPlanningRouteImport } from './routes/business-succession-planning'
import { Route as BuyersSolicitorQldRouteImport } from './routes/buyers-solicitor-qld'
import { Route as CaloundraRouteImport } from './routes/caloundra'
import { Route as CaseStudiesRouteImport } from './routes/case-studies'
import { Route as CommercialConveyancingRouteImport } from './routes/commercial-conveyancing'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConveyancingBrisbaneRouteImport } from './routes/conveyancing-brisbane'
import { Route as ConveyancingCostQldRouteImport } from './routes/conveyancing-cost-qld'
import { Route as ConveyancingNearMeRouteImport } from './routes/conveyancing-near-me'
import { Route as ConveyancingServicesRouteImport } from './routes/conveyancing-services'
import { Route as ConveyancingSunshineCoastRouteImport } from './routes/conveyancing-sunshine-coast'
import { Route as CoolingOffPeriodQldRouteImport } from './routes/cooling-off-period-qld'
import { Route as CostToContestAWillRouteImport } from './routes/cost-to-contest-a-will'
import { Route as CurrimundiRouteImport } from './routes/currimundi'
import { Route as DickyBeachRouteImport } from './routes/dicky-beach'
import { Route as DirectoryListingsRouteImport } from './routes/directory-listings'
import { Route as DirectoryListingsScarboroughRouteImport } from './routes/directory-listings-scarborough'
import { Route as ElderLawRouteImport } from './routes/elder-law'
import { Route as EnquiryTrackingRouteImport } from './routes/enquiry-tracking'
import { Route as ExecutorIntakeRouteImport } from './routes/executor-intake'
import { Route as ExecutorQueenslandRouteImport } from './routes/executor-queensland'
import { Route as FaqsRouteImport } from './routes/faqs'
import { Route as FeesRouteImport } from './routes/fees'
import { Route as FirstNationalMoretonRouteImport } from './routes/first-national-moreton'
import { Route as FirstNationalMoretonEstatePlanningRouteImport } from './routes/first-national-moreton-estate-planning'
import { Route as FixedPriceWillSolicitorRouteImport } from './routes/fixed-price-will-solicitor'
import { Route as Form2BuyerRightsQldRouteImport } from './routes/form-2-buyer-rights-qld'
import { Route as GoldenBeachRouteImport } from './routes/golden-beach'
import { Route as GoogleBusinessProfileRouteImport } from './routes/google-business-profile'
import { Route as GrannyFlatConsultationRouteImport } from './routes/granny-flat-consultation'
import { Route as GrannyFlatResourcesRouteImport } from './routes/granny-flat-resources'
import { Route as GympieRouteImport } from './routes/gympie'
import { Route as HerveyBayRouteImport } from './routes/hervey-bay'
import { Route as HomeHospitalWillsSunshineCoastRouteImport } from './routes/home-hospital-wills-sunshine-coast'
import { Route as HowToAppointAnExecutorRouteImport } from './routes/how-to-appoint-an-executor'
import { Route as IndependentLegalAdviceRouteImport } from './routes/independent-legal-advice'
import { Route as KingsBeachRouteImport } from './routes/kings-beach'
import { Route as LittleMountainRouteImport } from './routes/little-mountain'
import { Route as LocalGuidesRouteImport } from './routes/local-guides'
import { Route as MaroochydoreRouteImport } from './routes/maroochydore'
import { Route as MaryboroughRouteImport } from './routes/maryborough'
import { Route as MeridanPlainsRouteImport } from './routes/meridan-plains'
import { Route as MichaelKleinRouteImport } from './routes/michael-klein'
import { Route as MoffatBeachRouteImport } from './routes/moffat-beach'
import { Route as MooloolabaRouteImport } from './routes/mooloolaba'
import { Route as MortgageBrokerConveyancingQldRouteImport } from './routes/mortgage-broker-conveyancing-qld'
import { Route as NoosaRouteImport } from './routes/noosa'
import { Route as OffThePlanContractsRouteImport } from './routes/off-the-plan-contracts'
import { Route as OurPeopleRouteImport } from './routes/our-people'
import { Route as PelicanWatersRouteImport } from './routes/pelican-waters'
import { Route as PexaSettlementRouteImport } from './routes/pexa-settlement'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProbateChecklistQueenslandRouteImport } from './routes/probate-checklist-queensland'
import { Route as ProbateEnquiryRouteImport } from './routes/probate-enquiry'
import { Route as ProbateQueenslandRouteImport } from './routes/probate-queensland'
import { Route as ProbateSolicitorBrisbaneRouteImport } from './routes/probate-solicitor-brisbane'
import { Route as QueenslandLawSocietyRouteImport } from './routes/queensland-law-society'
import { Route as RedcliffeConveyancingRouteImport } from './routes/redcliffe-conveyancing'
import { Route as ReidCoRouteImport } from './routes/reid-co'
import { Route as RetailShopLeaseFaqsRouteImport } from './routes/retail-shop-lease-faqs'
import { Route as RetailShopLeasesRouteImport } from './routes/retail-shop-leases'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ScarboroughRouteImport } from './routes/scarborough'
import { Route as ScarboroughOfficeRouteImport } from './routes/scarborough-office'
import { Route as ScarboroughWillsAndEstatesRouteImport } from './routes/scarborough-wills-and-estates'
import { Route as SellerDisclosureRouteImport } from './routes/seller-disclosure'
import { Route as SellingABusinessQueenslandRouteImport } from './routes/selling-a-business-queensland'
import { Route as SellingDeceasedEstatePropertyQldRouteImport } from './routes/selling-deceased-estate-property-qld'
import { Route as ShareholderAgreementsRouteImport } from './routes/shareholder-agreements'
import { Route as ShellyBeachRouteImport } from './routes/shelly-beach'
import { Route as SpecialConditionsContractQldRouteImport } from './routes/special-conditions-contract-qld'
import { Route as StampDutyCalculatorQldRouteImport } from './routes/stamp-duty-calculator-qld'
import { Route as SunsetDateOffThePlanQldRouteImport } from './routes/sunset-date-off-the-plan-qld'
import { Route as SunshineCoastRouteImport } from './routes/sunshine-coast'
import { Route as TestamentaryTrustsRouteImport } from './routes/testamentary-trusts'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as TransferMyWillFromAnotherFirmRouteImport } from './routes/transfer-my-will-from-another-firm'
import { Route as TransferPropertyToFamilyQldRouteImport } from './routes/transfer-property-to-family-qld'
import { Route as WhatDoesAConveyancerDoQldRouteImport } from './routes/what-does-a-conveyancer-do-qld'
import { Route as WhatHappensWhenSomeoneDiesQueenslandRouteImport } from './routes/what-happens-when-someone-dies-queensland'
import { Route as WillCapacityFaqsRouteImport } from './routes/will-capacity-faqs'
import { Route as WillSafeCustodyRouteImport } from './routes/will-safe-custody'
import { Route as WillsAndEstatesRouteImport } from './routes/wills-and-estates'
import { Route as WillsAndProbateGoldenBeachRouteImport } from './routes/wills-and-probate-golden-beach'
import { Route as WillsAndProbateLittleMountainRouteImport } from './routes/wills-and-probate-little-mountain'
import { Route as WillsAndProbateQueenslandRouteImport } from './routes/wills-and-probate-queensland'
import { Route as WillsAndProbateScarboroughRouteImport } from './routes/wills-and-probate-scarborough'
import { Route as WillsEstateLawyersSunshineCoastRouteImport } from './routes/wills-estate-lawyers-sunshine-coast'
import { Route as WurtullaRouteImport } from './routes/wurtulla'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BusinessLawyersIndexRouteImport } from './routes/business-lawyers.index'
import { Route as BusinessLawyersSuburbRouteImport } from './routes/business-lawyers.$suburb'
import { Route as ConveyancingIndexRouteImport } from './routes/conveyancing.index'
import { Route as ConveyancingSuburbRouteImport } from './routes/conveyancing.$suburb'
import { Route as EstateDisputesIndexRouteImport } from './routes/estate-disputes.index'
import { Route as EstateDisputesSuburbRouteImport } from './routes/estate-disputes.$suburb'
import { Route as GuidesIndexRouteImport } from './routes/guides.index'
import { Route as GuidesSlugRouteImport } from './routes/guides.$slug'
import { Route as MoretonBayIndexRouteImport } from './routes/moreton-bay.index'
import { Route as MoretonBaySuburbRouteImport } from './routes/moreton-bay.$suburb'
import { Route as ProbateIndexRouteImport } from './routes/probate.index'
import { Route as ProbateSuburbRouteImport } from './routes/probate.$suburb'
import { Route as RemoteProbateIndexRouteImport } from './routes/remote-probate.index'
import { Route as RemoteProbateRegionRouteImport } from './routes/remote-probate.$region'
import { Route as SellingIndexRouteImport } from './routes/selling.index'
import { Route as SellingSuburbRouteImport } from './routes/selling.$suburb'
import { Route as WideBayIndexRouteImport } from './routes/wide-bay.index'
import { Route as WideBaySuburbRouteImport } from './routes/wide-bay.$suburb'
import { Route as WillsSuburbRouteImport } from './routes/wills.$suburb'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AgentUpdatesRoute = AgentUpdatesRouteImport.update({
            id: '/agent-updates',path: '/agent-updates',getParentRoute: () => rootRouteImport
          })
const AmlRealEstateAgentsRoute = AmlRealEstateAgentsRouteImport.update({
            id: '/aml-real-estate-agents',path: '/aml-real-estate-agents',getParentRoute: () => rootRouteImport
          })
const AnalyticsRoute = AnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => rootRouteImport
          })
const AroonaRoute = AroonaRouteImport.update({
            id: '/aroona',path: '/aroona',getParentRoute: () => rootRouteImport
          })
const BaringaRoute = BaringaRouteImport.update({
            id: '/baringa',path: '/baringa',getParentRoute: () => rootRouteImport
          })
const BatteryHillRoute = BatteryHillRouteImport.update({
            id: '/battery-hill',path: '/battery-hill',getParentRoute: () => rootRouteImport
          })
const BlueMoonPropertyRoute = BlueMoonPropertyRouteImport.update({
            id: '/blue-moon-property',path: '/blue-moon-property',getParentRoute: () => rootRouteImport
          })
const BodyCorporateScarboroughRoute = BodyCorporateScarboroughRouteImport.update({
            id: '/body-corporate-scarborough',path: '/body-corporate-scarborough',getParentRoute: () => rootRouteImport
          })
const BrisbaneRoute = BrisbaneRouteImport.update({
            id: '/brisbane',path: '/brisbane',getParentRoute: () => rootRouteImport
          })
const BuderimRoute = BuderimRouteImport.update({
            id: '/buderim',path: '/buderim',getParentRoute: () => rootRouteImport
          })
const BusinessSaleChecklistRoute = BusinessSaleChecklistRouteImport.update({
            id: '/business-sale-checklist',path: '/business-sale-checklist',getParentRoute: () => rootRouteImport
          })
const BusinessSalesRoute = BusinessSalesRouteImport.update({
            id: '/business-sales',path: '/business-sales',getParentRoute: () => rootRouteImport
          })
const BusinessSuccessionPlanningRoute = BusinessSuccessionPlanningRouteImport.update({
            id: '/business-succession-planning',path: '/business-succession-planning',getParentRoute: () => rootRouteImport
          })
const BuyersSolicitorQldRoute = BuyersSolicitorQldRouteImport.update({
            id: '/buyers-solicitor-qld',path: '/buyers-solicitor-qld',getParentRoute: () => rootRouteImport
          })
const CaloundraRoute = CaloundraRouteImport.update({
            id: '/caloundra',path: '/caloundra',getParentRoute: () => rootRouteImport
          })
const CaseStudiesRoute = CaseStudiesRouteImport.update({
            id: '/case-studies',path: '/case-studies',getParentRoute: () => rootRouteImport
          })
const CommercialConveyancingRoute = CommercialConveyancingRouteImport.update({
            id: '/commercial-conveyancing',path: '/commercial-conveyancing',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ConveyancingBrisbaneRoute = ConveyancingBrisbaneRouteImport.update({
            id: '/conveyancing-brisbane',path: '/conveyancing-brisbane',getParentRoute: () => rootRouteImport
          })
const ConveyancingCostQldRoute = ConveyancingCostQldRouteImport.update({
            id: '/conveyancing-cost-qld',path: '/conveyancing-cost-qld',getParentRoute: () => rootRouteImport
          })
const ConveyancingNearMeRoute = ConveyancingNearMeRouteImport.update({
            id: '/conveyancing-near-me',path: '/conveyancing-near-me',getParentRoute: () => rootRouteImport
          })
const ConveyancingServicesRoute = ConveyancingServicesRouteImport.update({
            id: '/conveyancing-services',path: '/conveyancing-services',getParentRoute: () => rootRouteImport
          })
const ConveyancingSunshineCoastRoute = ConveyancingSunshineCoastRouteImport.update({
            id: '/conveyancing-sunshine-coast',path: '/conveyancing-sunshine-coast',getParentRoute: () => rootRouteImport
          })
const CoolingOffPeriodQldRoute = CoolingOffPeriodQldRouteImport.update({
            id: '/cooling-off-period-qld',path: '/cooling-off-period-qld',getParentRoute: () => rootRouteImport
          })
const CostToContestAWillRoute = CostToContestAWillRouteImport.update({
            id: '/cost-to-contest-a-will',path: '/cost-to-contest-a-will',getParentRoute: () => rootRouteImport
          })
const CurrimundiRoute = CurrimundiRouteImport.update({
            id: '/currimundi',path: '/currimundi',getParentRoute: () => rootRouteImport
          })
const DickyBeachRoute = DickyBeachRouteImport.update({
            id: '/dicky-beach',path: '/dicky-beach',getParentRoute: () => rootRouteImport
          })
const DirectoryListingsRoute = DirectoryListingsRouteImport.update({
            id: '/directory-listings',path: '/directory-listings',getParentRoute: () => rootRouteImport
          })
const DirectoryListingsScarboroughRoute = DirectoryListingsScarboroughRouteImport.update({
            id: '/directory-listings-scarborough',path: '/directory-listings-scarborough',getParentRoute: () => rootRouteImport
          })
const ElderLawRoute = ElderLawRouteImport.update({
            id: '/elder-law',path: '/elder-law',getParentRoute: () => rootRouteImport
          })
const EnquiryTrackingRoute = EnquiryTrackingRouteImport.update({
            id: '/enquiry-tracking',path: '/enquiry-tracking',getParentRoute: () => rootRouteImport
          })
const ExecutorIntakeRoute = ExecutorIntakeRouteImport.update({
            id: '/executor-intake',path: '/executor-intake',getParentRoute: () => rootRouteImport
          })
const ExecutorQueenslandRoute = ExecutorQueenslandRouteImport.update({
            id: '/executor-queensland',path: '/executor-queensland',getParentRoute: () => rootRouteImport
          })
const FaqsRoute = FaqsRouteImport.update({
            id: '/faqs',path: '/faqs',getParentRoute: () => rootRouteImport
          })
const FeesRoute = FeesRouteImport.update({
            id: '/fees',path: '/fees',getParentRoute: () => rootRouteImport
          })
const FirstNationalMoretonRoute = FirstNationalMoretonRouteImport.update({
            id: '/first-national-moreton',path: '/first-national-moreton',getParentRoute: () => rootRouteImport
          })
const FirstNationalMoretonEstatePlanningRoute = FirstNationalMoretonEstatePlanningRouteImport.update({
            id: '/first-national-moreton-estate-planning',path: '/first-national-moreton-estate-planning',getParentRoute: () => rootRouteImport
          })
const FixedPriceWillSolicitorRoute = FixedPriceWillSolicitorRouteImport.update({
            id: '/fixed-price-will-solicitor',path: '/fixed-price-will-solicitor',getParentRoute: () => rootRouteImport
          })
const Form2BuyerRightsQldRoute = Form2BuyerRightsQldRouteImport.update({
            id: '/form-2-buyer-rights-qld',path: '/form-2-buyer-rights-qld',getParentRoute: () => rootRouteImport
          })
const GoldenBeachRoute = GoldenBeachRouteImport.update({
            id: '/golden-beach',path: '/golden-beach',getParentRoute: () => rootRouteImport
          })
const GoogleBusinessProfileRoute = GoogleBusinessProfileRouteImport.update({
            id: '/google-business-profile',path: '/google-business-profile',getParentRoute: () => rootRouteImport
          })
const GrannyFlatConsultationRoute = GrannyFlatConsultationRouteImport.update({
            id: '/granny-flat-consultation',path: '/granny-flat-consultation',getParentRoute: () => rootRouteImport
          })
const GrannyFlatResourcesRoute = GrannyFlatResourcesRouteImport.update({
            id: '/granny-flat-resources',path: '/granny-flat-resources',getParentRoute: () => rootRouteImport
          })
const GympieRoute = GympieRouteImport.update({
            id: '/gympie',path: '/gympie',getParentRoute: () => rootRouteImport
          })
const HerveyBayRoute = HerveyBayRouteImport.update({
            id: '/hervey-bay',path: '/hervey-bay',getParentRoute: () => rootRouteImport
          })
const HomeHospitalWillsSunshineCoastRoute = HomeHospitalWillsSunshineCoastRouteImport.update({
            id: '/home-hospital-wills-sunshine-coast',path: '/home-hospital-wills-sunshine-coast',getParentRoute: () => rootRouteImport
          })
const HowToAppointAnExecutorRoute = HowToAppointAnExecutorRouteImport.update({
            id: '/how-to-appoint-an-executor',path: '/how-to-appoint-an-executor',getParentRoute: () => rootRouteImport
          })
const IndependentLegalAdviceRoute = IndependentLegalAdviceRouteImport.update({
            id: '/independent-legal-advice',path: '/independent-legal-advice',getParentRoute: () => rootRouteImport
          })
const KingsBeachRoute = KingsBeachRouteImport.update({
            id: '/kings-beach',path: '/kings-beach',getParentRoute: () => rootRouteImport
          })
const LittleMountainRoute = LittleMountainRouteImport.update({
            id: '/little-mountain',path: '/little-mountain',getParentRoute: () => rootRouteImport
          })
const LocalGuidesRoute = LocalGuidesRouteImport.update({
            id: '/local-guides',path: '/local-guides',getParentRoute: () => rootRouteImport
          })
const MaroochydoreRoute = MaroochydoreRouteImport.update({
            id: '/maroochydore',path: '/maroochydore',getParentRoute: () => rootRouteImport
          })
const MaryboroughRoute = MaryboroughRouteImport.update({
            id: '/maryborough',path: '/maryborough',getParentRoute: () => rootRouteImport
          })
const MeridanPlainsRoute = MeridanPlainsRouteImport.update({
            id: '/meridan-plains',path: '/meridan-plains',getParentRoute: () => rootRouteImport
          })
const MichaelKleinRoute = MichaelKleinRouteImport.update({
            id: '/michael-klein',path: '/michael-klein',getParentRoute: () => rootRouteImport
          })
const MoffatBeachRoute = MoffatBeachRouteImport.update({
            id: '/moffat-beach',path: '/moffat-beach',getParentRoute: () => rootRouteImport
          })
const MooloolabaRoute = MooloolabaRouteImport.update({
            id: '/mooloolaba',path: '/mooloolaba',getParentRoute: () => rootRouteImport
          })
const MortgageBrokerConveyancingQldRoute = MortgageBrokerConveyancingQldRouteImport.update({
            id: '/mortgage-broker-conveyancing-qld',path: '/mortgage-broker-conveyancing-qld',getParentRoute: () => rootRouteImport
          })
const NoosaRoute = NoosaRouteImport.update({
            id: '/noosa',path: '/noosa',getParentRoute: () => rootRouteImport
          })
const OffThePlanContractsRoute = OffThePlanContractsRouteImport.update({
            id: '/off-the-plan-contracts',path: '/off-the-plan-contracts',getParentRoute: () => rootRouteImport
          })
const OurPeopleRoute = OurPeopleRouteImport.update({
            id: '/our-people',path: '/our-people',getParentRoute: () => rootRouteImport
          })
const PelicanWatersRoute = PelicanWatersRouteImport.update({
            id: '/pelican-waters',path: '/pelican-waters',getParentRoute: () => rootRouteImport
          })
const PexaSettlementRoute = PexaSettlementRouteImport.update({
            id: '/pexa-settlement',path: '/pexa-settlement',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProbateChecklistQueenslandRoute = ProbateChecklistQueenslandRouteImport.update({
            id: '/probate-checklist-queensland',path: '/probate-checklist-queensland',getParentRoute: () => rootRouteImport
          })
const ProbateEnquiryRoute = ProbateEnquiryRouteImport.update({
            id: '/probate-enquiry',path: '/probate-enquiry',getParentRoute: () => rootRouteImport
          })
const ProbateQueenslandRoute = ProbateQueenslandRouteImport.update({
            id: '/probate-queensland',path: '/probate-queensland',getParentRoute: () => rootRouteImport
          })
const ProbateSolicitorBrisbaneRoute = ProbateSolicitorBrisbaneRouteImport.update({
            id: '/probate-solicitor-brisbane',path: '/probate-solicitor-brisbane',getParentRoute: () => rootRouteImport
          })
const QueenslandLawSocietyRoute = QueenslandLawSocietyRouteImport.update({
            id: '/queensland-law-society',path: '/queensland-law-society',getParentRoute: () => rootRouteImport
          })
const RedcliffeConveyancingRoute = RedcliffeConveyancingRouteImport.update({
            id: '/redcliffe-conveyancing',path: '/redcliffe-conveyancing',getParentRoute: () => rootRouteImport
          })
const ReidCoRoute = ReidCoRouteImport.update({
            id: '/reid-co',path: '/reid-co',getParentRoute: () => rootRouteImport
          })
const RetailShopLeaseFaqsRoute = RetailShopLeaseFaqsRouteImport.update({
            id: '/retail-shop-lease-faqs',path: '/retail-shop-lease-faqs',getParentRoute: () => rootRouteImport
          })
const RetailShopLeasesRoute = RetailShopLeasesRouteImport.update({
            id: '/retail-shop-leases',path: '/retail-shop-leases',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const ScarboroughRoute = ScarboroughRouteImport.update({
            id: '/scarborough',path: '/scarborough',getParentRoute: () => rootRouteImport
          })
const ScarboroughOfficeRoute = ScarboroughOfficeRouteImport.update({
            id: '/scarborough-office',path: '/scarborough-office',getParentRoute: () => rootRouteImport
          })
const ScarboroughWillsAndEstatesRoute = ScarboroughWillsAndEstatesRouteImport.update({
            id: '/scarborough-wills-and-estates',path: '/scarborough-wills-and-estates',getParentRoute: () => rootRouteImport
          })
const SellerDisclosureRoute = SellerDisclosureRouteImport.update({
            id: '/seller-disclosure',path: '/seller-disclosure',getParentRoute: () => rootRouteImport
          })
const SellingABusinessQueenslandRoute = SellingABusinessQueenslandRouteImport.update({
            id: '/selling-a-business-queensland',path: '/selling-a-business-queensland',getParentRoute: () => rootRouteImport
          })
const SellingDeceasedEstatePropertyQldRoute = SellingDeceasedEstatePropertyQldRouteImport.update({
            id: '/selling-deceased-estate-property-qld',path: '/selling-deceased-estate-property-qld',getParentRoute: () => rootRouteImport
          })
const ShareholderAgreementsRoute = ShareholderAgreementsRouteImport.update({
            id: '/shareholder-agreements',path: '/shareholder-agreements',getParentRoute: () => rootRouteImport
          })
const ShellyBeachRoute = ShellyBeachRouteImport.update({
            id: '/shelly-beach',path: '/shelly-beach',getParentRoute: () => rootRouteImport
          })
const SpecialConditionsContractQldRoute = SpecialConditionsContractQldRouteImport.update({
            id: '/special-conditions-contract-qld',path: '/special-conditions-contract-qld',getParentRoute: () => rootRouteImport
          })
const StampDutyCalculatorQldRoute = StampDutyCalculatorQldRouteImport.update({
            id: '/stamp-duty-calculator-qld',path: '/stamp-duty-calculator-qld',getParentRoute: () => rootRouteImport
          })
const SunsetDateOffThePlanQldRoute = SunsetDateOffThePlanQldRouteImport.update({
            id: '/sunset-date-off-the-plan-qld',path: '/sunset-date-off-the-plan-qld',getParentRoute: () => rootRouteImport
          })
const SunshineCoastRoute = SunshineCoastRouteImport.update({
            id: '/sunshine-coast',path: '/sunshine-coast',getParentRoute: () => rootRouteImport
          })
const TestamentaryTrustsRoute = TestamentaryTrustsRouteImport.update({
            id: '/testamentary-trusts',path: '/testamentary-trusts',getParentRoute: () => rootRouteImport
          })
const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const TransferMyWillFromAnotherFirmRoute = TransferMyWillFromAnotherFirmRouteImport.update({
            id: '/transfer-my-will-from-another-firm',path: '/transfer-my-will-from-another-firm',getParentRoute: () => rootRouteImport
          })
const TransferPropertyToFamilyQldRoute = TransferPropertyToFamilyQldRouteImport.update({
            id: '/transfer-property-to-family-qld',path: '/transfer-property-to-family-qld',getParentRoute: () => rootRouteImport
          })
const WhatDoesAConveyancerDoQldRoute = WhatDoesAConveyancerDoQldRouteImport.update({
            id: '/what-does-a-conveyancer-do-qld',path: '/what-does-a-conveyancer-do-qld',getParentRoute: () => rootRouteImport
          })
const WhatHappensWhenSomeoneDiesQueenslandRoute = WhatHappensWhenSomeoneDiesQueenslandRouteImport.update({
            id: '/what-happens-when-someone-dies-queensland',path: '/what-happens-when-someone-dies-queensland',getParentRoute: () => rootRouteImport
          })
const WillCapacityFaqsRoute = WillCapacityFaqsRouteImport.update({
            id: '/will-capacity-faqs',path: '/will-capacity-faqs',getParentRoute: () => rootRouteImport
          })
const WillSafeCustodyRoute = WillSafeCustodyRouteImport.update({
            id: '/will-safe-custody',path: '/will-safe-custody',getParentRoute: () => rootRouteImport
          })
const WillsAndEstatesRoute = WillsAndEstatesRouteImport.update({
            id: '/wills-and-estates',path: '/wills-and-estates',getParentRoute: () => rootRouteImport
          })
const WillsAndProbateGoldenBeachRoute = WillsAndProbateGoldenBeachRouteImport.update({
            id: '/wills-and-probate-golden-beach',path: '/wills-and-probate-golden-beach',getParentRoute: () => rootRouteImport
          })
const WillsAndProbateLittleMountainRoute = WillsAndProbateLittleMountainRouteImport.update({
            id: '/wills-and-probate-little-mountain',path: '/wills-and-probate-little-mountain',getParentRoute: () => rootRouteImport
          })
const WillsAndProbateQueenslandRoute = WillsAndProbateQueenslandRouteImport.update({
            id: '/wills-and-probate-queensland',path: '/wills-and-probate-queensland',getParentRoute: () => rootRouteImport
          })
const WillsAndProbateScarboroughRoute = WillsAndProbateScarboroughRouteImport.update({
            id: '/wills-and-probate-scarborough',path: '/wills-and-probate-scarborough',getParentRoute: () => rootRouteImport
          })
const WillsEstateLawyersSunshineCoastRoute = WillsEstateLawyersSunshineCoastRouteImport.update({
            id: '/wills-estate-lawyers-sunshine-coast',path: '/wills-estate-lawyers-sunshine-coast',getParentRoute: () => rootRouteImport
          })
const WurtullaRoute = WurtullaRouteImport.update({
            id: '/wurtulla',path: '/wurtulla',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BusinessLawyersIndexRoute = BusinessLawyersIndexRouteImport.update({
            id: '/business-lawyers/',path: '/business-lawyers/',getParentRoute: () => rootRouteImport
          })
const BusinessLawyersSuburbRoute = BusinessLawyersSuburbRouteImport.update({
            id: '/business-lawyers/$suburb',path: '/business-lawyers/$suburb',getParentRoute: () => rootRouteImport
          })
const ConveyancingIndexRoute = ConveyancingIndexRouteImport.update({
            id: '/conveyancing/',path: '/conveyancing/',getParentRoute: () => rootRouteImport
          })
const ConveyancingSuburbRoute = ConveyancingSuburbRouteImport.update({
            id: '/conveyancing/$suburb',path: '/conveyancing/$suburb',getParentRoute: () => rootRouteImport
          })
const EstateDisputesIndexRoute = EstateDisputesIndexRouteImport.update({
            id: '/estate-disputes/',path: '/estate-disputes/',getParentRoute: () => rootRouteImport
          })
const EstateDisputesSuburbRoute = EstateDisputesSuburbRouteImport.update({
            id: '/estate-disputes/$suburb',path: '/estate-disputes/$suburb',getParentRoute: () => rootRouteImport
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })
const MoretonBayIndexRoute = MoretonBayIndexRouteImport.update({
            id: '/moreton-bay/',path: '/moreton-bay/',getParentRoute: () => rootRouteImport
          })
const MoretonBaySuburbRoute = MoretonBaySuburbRouteImport.update({
            id: '/moreton-bay/$suburb',path: '/moreton-bay/$suburb',getParentRoute: () => rootRouteImport
          })
const ProbateIndexRoute = ProbateIndexRouteImport.update({
            id: '/probate/',path: '/probate/',getParentRoute: () => rootRouteImport
          })
const ProbateSuburbRoute = ProbateSuburbRouteImport.update({
            id: '/probate/$suburb',path: '/probate/$suburb',getParentRoute: () => rootRouteImport
          })
const RemoteProbateIndexRoute = RemoteProbateIndexRouteImport.update({
            id: '/remote-probate/',path: '/remote-probate/',getParentRoute: () => rootRouteImport
          })
const RemoteProbateRegionRoute = RemoteProbateRegionRouteImport.update({
            id: '/remote-probate/$region',path: '/remote-probate/$region',getParentRoute: () => rootRouteImport
          })
const SellingIndexRoute = SellingIndexRouteImport.update({
            id: '/selling/',path: '/selling/',getParentRoute: () => rootRouteImport
          })
const SellingSuburbRoute = SellingSuburbRouteImport.update({
            id: '/selling/$suburb',path: '/selling/$suburb',getParentRoute: () => rootRouteImport
          })
const WideBayIndexRoute = WideBayIndexRouteImport.update({
            id: '/wide-bay/',path: '/wide-bay/',getParentRoute: () => rootRouteImport
          })
const WideBaySuburbRoute = WideBaySuburbRouteImport.update({
            id: '/wide-bay/$suburb',path: '/wide-bay/$suburb',getParentRoute: () => rootRouteImport
          })
const WillsSuburbRoute = WillsSuburbRouteImport.update({
            id: '/wills/$suburb',path: '/wills/$suburb',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AgentUpdatesRoute: AgentUpdatesRoute,AmlRealEstateAgentsRoute: AmlRealEstateAgentsRoute,AnalyticsRoute: AnalyticsRoute,AroonaRoute: AroonaRoute,BaringaRoute: BaringaRoute,BatteryHillRoute: BatteryHillRoute,BlueMoonPropertyRoute: BlueMoonPropertyRoute,BodyCorporateScarboroughRoute: BodyCorporateScarboroughRoute,BrisbaneRoute: BrisbaneRoute,BuderimRoute: BuderimRoute,BusinessSaleChecklistRoute: BusinessSaleChecklistRoute,BusinessSalesRoute: BusinessSalesRoute,BusinessSuccessionPlanningRoute: BusinessSuccessionPlanningRoute,BuyersSolicitorQldRoute: BuyersSolicitorQldRoute,CaloundraRoute: CaloundraRoute,CaseStudiesRoute: CaseStudiesRoute,CommercialConveyancingRoute: CommercialConveyancingRoute,ContactRoute: ContactRoute,ConveyancingBrisbaneRoute: ConveyancingBrisbaneRoute,ConveyancingCostQldRoute: ConveyancingCostQldRoute,ConveyancingNearMeRoute: ConveyancingNearMeRoute,ConveyancingServicesRoute: ConveyancingServicesRoute,ConveyancingSunshineCoastRoute: ConveyancingSunshineCoastRoute,CoolingOffPeriodQldRoute: CoolingOffPeriodQldRoute,CostToContestAWillRoute: CostToContestAWillRoute,CurrimundiRoute: CurrimundiRoute,DickyBeachRoute: DickyBeachRoute,DirectoryListingsRoute: DirectoryListingsRoute,DirectoryListingsScarboroughRoute: DirectoryListingsScarboroughRoute,ElderLawRoute: ElderLawRoute,EnquiryTrackingRoute: EnquiryTrackingRoute,ExecutorIntakeRoute: ExecutorIntakeRoute,ExecutorQueenslandRoute: ExecutorQueenslandRoute,FaqsRoute: FaqsRoute,FeesRoute: FeesRoute,FirstNationalMoretonRoute: FirstNationalMoretonRoute,FirstNationalMoretonEstatePlanningRoute: FirstNationalMoretonEstatePlanningRoute,FixedPriceWillSolicitorRoute: FixedPriceWillSolicitorRoute,Form2BuyerRightsQldRoute: Form2BuyerRightsQldRoute,GoldenBeachRoute: GoldenBeachRoute,GoogleBusinessProfileRoute: GoogleBusinessProfileRoute,GrannyFlatConsultationRoute: GrannyFlatConsultationRoute,GrannyFlatResourcesRoute: GrannyFlatResourcesRoute,GympieRoute: GympieRoute,HerveyBayRoute: HerveyBayRoute,HomeHospitalWillsSunshineCoastRoute: HomeHospitalWillsSunshineCoastRoute,HowToAppointAnExecutorRoute: HowToAppointAnExecutorRoute,IndependentLegalAdviceRoute: IndependentLegalAdviceRoute,KingsBeachRoute: KingsBeachRoute,LittleMountainRoute: LittleMountainRoute,LocalGuidesRoute: LocalGuidesRoute,MaroochydoreRoute: MaroochydoreRoute,MaryboroughRoute: MaryboroughRoute,MeridanPlainsRoute: MeridanPlainsRoute,MichaelKleinRoute: MichaelKleinRoute,MoffatBeachRoute: MoffatBeachRoute,MooloolabaRoute: MooloolabaRoute,MortgageBrokerConveyancingQldRoute: MortgageBrokerConveyancingQldRoute,NoosaRoute: NoosaRoute,OffThePlanContractsRoute: OffThePlanContractsRoute,OurPeopleRoute: OurPeopleRoute,PelicanWatersRoute: PelicanWatersRoute,PexaSettlementRoute: PexaSettlementRoute,PrivacyRoute: PrivacyRoute,ProbateChecklistQueenslandRoute: ProbateChecklistQueenslandRoute,ProbateEnquiryRoute: ProbateEnquiryRoute,ProbateQueenslandRoute: ProbateQueenslandRoute,ProbateSolicitorBrisbaneRoute: ProbateSolicitorBrisbaneRoute,QueenslandLawSocietyRoute: QueenslandLawSocietyRoute,RedcliffeConveyancingRoute: RedcliffeConveyancingRoute,ReidCoRoute: ReidCoRoute,RetailShopLeaseFaqsRoute: RetailShopLeaseFaqsRoute,RetailShopLeasesRoute: RetailShopLeasesRoute,ReviewsRoute: ReviewsRoute,ScarboroughRoute: ScarboroughRoute,ScarboroughOfficeRoute: ScarboroughOfficeRoute,ScarboroughWillsAndEstatesRoute: ScarboroughWillsAndEstatesRoute,SellerDisclosureRoute: SellerDisclosureRoute,SellingABusinessQueenslandRoute: SellingABusinessQueenslandRoute,SellingDeceasedEstatePropertyQldRoute: SellingDeceasedEstatePropertyQldRoute,ShareholderAgreementsRoute: ShareholderAgreementsRoute,ShellyBeachRoute: ShellyBeachRoute,SpecialConditionsContractQldRoute: SpecialConditionsContractQldRoute,StampDutyCalculatorQldRoute: StampDutyCalculatorQldRoute,SunsetDateOffThePlanQldRoute: SunsetDateOffThePlanQldRoute,SunshineCoastRoute: SunshineCoastRoute,TestamentaryTrustsRoute: TestamentaryTrustsRoute,ThankYouRoute: ThankYouRoute,TransferMyWillFromAnotherFirmRoute: TransferMyWillFromAnotherFirmRoute,TransferPropertyToFamilyQldRoute: TransferPropertyToFamilyQldRoute,WhatDoesAConveyancerDoQldRoute: WhatDoesAConveyancerDoQldRoute,WhatHappensWhenSomeoneDiesQueenslandRoute: WhatHappensWhenSomeoneDiesQueenslandRoute,WillCapacityFaqsRoute: WillCapacityFaqsRoute,WillSafeCustodyRoute: WillSafeCustodyRoute,WillsAndEstatesRoute: WillsAndEstatesRoute,WillsAndProbateGoldenBeachRoute: WillsAndProbateGoldenBeachRoute,WillsAndProbateLittleMountainRoute: WillsAndProbateLittleMountainRoute,WillsAndProbateQueenslandRoute: WillsAndProbateQueenslandRoute,WillsAndProbateScarboroughRoute: WillsAndProbateScarboroughRoute,WillsEstateLawyersSunshineCoastRoute: WillsEstateLawyersSunshineCoastRoute,WurtullaRoute: WurtullaRoute,BlogSlugRoute: BlogSlugRoute,BusinessLawyersSuburbRoute: BusinessLawyersSuburbRoute,ConveyancingSuburbRoute: ConveyancingSuburbRoute,EstateDisputesSuburbRoute: EstateDisputesSuburbRoute,GuidesSlugRoute: GuidesSlugRoute,MoretonBaySuburbRoute: MoretonBaySuburbRoute,ProbateSuburbRoute: ProbateSuburbRoute,RemoteProbateRegionRoute: RemoteProbateRegionRoute,SellingSuburbRoute: SellingSuburbRoute,WideBaySuburbRoute: WideBaySuburbRoute,WillsSuburbRoute: WillsSuburbRoute,BlogIndexRoute: BlogIndexRoute,BusinessLawyersIndexRoute: BusinessLawyersIndexRoute,ConveyancingIndexRoute: ConveyancingIndexRoute,EstateDisputesIndexRoute: EstateDisputesIndexRoute,GuidesIndexRoute: GuidesIndexRoute,MoretonBayIndexRoute: MoretonBayIndexRoute,ProbateIndexRoute: ProbateIndexRoute,RemoteProbateIndexRoute: RemoteProbateIndexRoute,SellingIndexRoute: SellingIndexRoute,WideBayIndexRoute: WideBayIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)